<ng-container *ngIf="ready == false">
    <div class="text-center">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </div>
</ng-container>

<ng-container *ngIf="ready">
    <div class="container">
        <p style="font-weight: bold;">Conversación - {{ticket.subject}}</p>

        <div class="col text-start conversation-left">
            <p style="text-decoration-line: underline;text-decoration-color: green;">{{ticket.name}} escribió en
                {{ticket.date | date:"HH:mm 'on' EEEE '-' dd/MM/yyyy"}}: </p>
            <p>{{ticket.message}}</p>
            <hr>
        </div>
        <ng-container *ngFor="let card of listTicketResponses; trackBy: trackByIndex">
            <div class="col" [ngClass]="user.username === card.name ? 'text-start conversation-left' : 'text-end conversation-right'">
                <p style="text-decoration-line: underline;text-decoration-color: green;">{{card.name}} escribió en
                    {{card.date | date:"HH:mm 'on' EEEE '-' dd/MM/yyyy"}}: </p>
                <p>{{card.message}}</p>
            </div>
            <hr>
        </ng-container>

        <ng-container *ngIf="saving">
            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
        </ng-container>

        <ng-container *ngIf="enable">
            <form onkeypress="return event.keyCode != 13;">
                <div class="text-center">
                    <textarea placeholder="Mensaje" name="ticketResponse.message" [(ngModel)]="ticketResponse.message"
                        rows="4" cols="50"></textarea>
                    <br />
                    <button button mat-stroked-button color="accent" mat-button (click)="save()">
                        Guardar respuesta
                    </button>
                    <br />
                </div>
            </form>
        </ng-container>
        <div class="text-center">
            <ng-container *ngIf="!ticket.resolved">
                <br />
                <button style="margin-right:20px" button mat-stroked-button color="primary" (click)="enableResponse()"
                    mat-button>
                    Responder
                </button>
            </ng-container>
            <button button mat-stroked-button color="primary" mat-button (click)="closeDialog()">
                Cerrar
            </button>
            <ng-container *ngIf="!ticket.resolved">
                <button style="margin-left:20px" button mat-stroked-button color="accent" (click)="resolveTicket()"
                    mat-button>
                    Cerrar Ticket
                </button>
            </ng-container>

            <br />
        </div>
    </div>
</ng-container>
